import { MxBaseMask } from './mx-mask-base';

export class MxRegExpMask extends MxBaseMask {
	constructor() {
		super();
	}

	createFormatter() {
		return null;
	}

	createParser() {
		return null;
	}
}
